/* ==========================================================================
   EMPIRE HOLLYWOOD — LUXE ENHANCE v6 (eh-luxe.js)
   ADDITIVE only. Never rewrites existing markup. Guarded / reduced-motion aware.
     · scroll progress bar
     · staggered scroll-reveal (homepage)
     · sparkle trail that follows movement  ── DESKTOP + MOBILE ──
     · tap / add-to-cart sparkle-burst delight
     · cursor-follow "spotlight" glow across product cards (desktop)
   v6 change: the diamond CURSOR is removed (cursor returns to normal). Only the
   sparkle trail remains, and it now also runs on touch devices.
   ========================================================================== */
(function(){
  if(window.__ehLuxe) return; window.__ehLuxe = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine   = window.matchMedia && window.matchMedia('(pointer: fine)').matches
               && window.matchMedia('(hover: hover)').matches;

  /* enter at the top of the page, not a browser-restored mid-page position */
  try{ if('scrollRestoration' in history) history.scrollRestoration = 'manual'; }catch(e){}

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    /* ---------- opening: land at top + a reliable SKIP on the CG intro ---------- */
    var toTop = function(){ try{ window.scrollTo(0,0); }catch(e2){} };
    try{
      toTop();
      var loader = document.querySelector('.fullpageLoader');
      if(loader){
        var mol = new MutationObserver(function(){
          if(loader.classList.contains('fullpageLoader--invisible')){ toTop(); setTimeout(toTop, 60); mol.disconnect(); }
        });
        mol.observe(loader, {attributes:true, attributeFilter:['class']});
      }
      window.addEventListener('load', toTop);

      /* The opening "CG" is the theme's full-screen .intro-window (video) with a
         native .intro-skip button. That button starts hidden (opacity:0) and is
         easy to miss (small, bottom-right). We force it visible immediately and
         guarantee the click dismisses the intro (belongs to the theme, but we
         make it robust). CSS repositions it bottom-centre as a bold gold pill. */
      var introWin  = document.querySelector('.intro-window');
      var introSkip = document.querySelector('.intro-skip');
      if(introSkip){
        introSkip.classList.add('is-visible');
        introSkip.addEventListener('click', function(){
          try{ if(typeof window.removeIntroWindow === 'function') window.removeIntroWindow(); else if(introWin) introWin.classList.add('fade-out'); }catch(e5){}
          try{ Array.prototype.forEach.call(document.querySelectorAll('.intro-window video'), function(v){ try{ v.pause(); v.muted = true; }catch(e6){} }); }catch(e7){}
          try{ var es = document.getElementById('enter-sound'); if(es){ es.pause(); } }catch(e8){}
          if(introWin){ setTimeout(function(){ try{ introWin.style.display = 'none'; }catch(e9){} }, 650); }
          toTop();
        });
      }
    }catch(e){}

    /* ---------- scroll progress bar ---------- */
    try{
      var bar = document.createElement('div');
      bar.className = 'eh-progress';
      document.body.appendChild(bar);
      var ticking = false;
      function upd(){
        var st = window.pageYOffset || document.documentElement.scrollTop || 0;
        var h  = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (h > 0 ? (st / h * 100) : 0) + '%';
        ticking = false;
      }
      function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(upd); } }
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onScroll, {passive:true});
      upd();
    }catch(e){}

    /* ---------- staggered scroll-reveal (homepage only) ---------- */
    try{
      if(!reduce && 'IntersectionObserver' in window && document.body.classList.contains('template-index')){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(en.isIntersecting){ en.target.classList.add('eh-in'); io.unobserve(en.target); }
          });
        }, {threshold:0.06, rootMargin:'0px 0px -5% 0px'});

        var vh = window.innerHeight || 800;
        var main = document.querySelector('.main-content') || document.body;
        var secs = main.querySelectorAll('.shopify-section');

        Array.prototype.forEach.call(secs, function(sec){
          if(sec.getAttribute('data-eh-seen')) return;
          if(sec.parentNode && sec.parentNode.closest && sec.parentNode.closest('.shopify-section')) return;
          sec.setAttribute('data-eh-seen','1');
          var cs = window.getComputedStyle(sec);
          if(cs.display === 'none' || cs.visibility === 'hidden') return;
          var r = sec.getBoundingClientRect();
          if(r.height < 8) return;
          if(r.top <= vh * 0.8) return;              /* above the fold → leave visible */

          sec.classList.add('eh-pre');

          var items = [];
          Array.prototype.push.apply(items, sec.querySelectorAll('.slick-carousel__item, .collection-item, .eh-catnav__item, .eh-rank__card'));
          Array.prototype.forEach.call(sec.querySelectorAll('.product-card'), function(pc){
            if(!pc.closest('.slick-carousel__item')) items.push(pc);
          });
          items.forEach(function(it, i){
            it.classList.add('eh-pre-item');
            it.style.transitionDelay = (Math.min(i, 14) * 0.055) + 's';
          });

          io.observe(sec);
        });

        Array.prototype.forEach.call(main.querySelectorAll('.wpbingo-title'), function(t){
          t.classList.add('wpbingo-title--accent');
          io.observe(t);
        });
      }
    }catch(e){}

    /* ---------- sparkle trail + tap-burst (desktop AND mobile) ---------- */
    if(!reduce){
      try{
        var cv = document.createElement('canvas');
        cv.className = 'eh-sparkles';
        document.body.appendChild(cv);
        var ctx = cv.getContext('2d');
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        function size(){ cv.width = innerWidth * dpr; cv.height = innerHeight * dpr; cv.style.width = innerWidth+'px'; cv.style.height = innerHeight+'px'; }
        size();
        window.addEventListener('resize', size);

        /* #385C60-based sparkle palette (brand teal → light teal → pale shimmer) */
        var COLORS = ['rgba(56,92,96,', 'rgba(127,176,181,', 'rgba(234,247,248,'];
        var sparks = [];
        function addSpark(x, y, scale){
          scale = scale || 1;
          sparks.push({ x:x*dpr, y:y*dpr, r:(3+Math.random()*5)*scale*dpr, life:0,
            spd:0.02+Math.random()*0.03, rot:Math.random()*Math.PI, c:COLORS[(Math.random()*COLORS.length)|0] });
          if(sparks.length > 90) sparks.shift();
        }
        function burst(x, y, n, scale){
          n = n || 10;
          for(var i=0;i<n;i++){
            var a = Math.random()*Math.PI*2, d = Math.random()*24;
            addSpark(x + Math.cos(a)*d, y + Math.sin(a)*d, scale || 1.15);
          }
          kick();
        }
        function drawStar(s){
          var e = s.life, a = Math.sin(e*Math.PI);
          var rr = s.r * (0.5 + a);
          ctx.save(); ctx.translate(s.x, s.y); ctx.rotate(s.rot + e*1.2);
          ctx.fillStyle = s.c + (a*0.95) + ')';
          ctx.beginPath();
          for(var i=0;i<8;i++){
            var ang = Math.PI/4 * i;
            var rad = (i % 2 === 0) ? rr : rr*0.28;
            var px = Math.cos(ang)*rad, py = Math.sin(ang)*rad;
            i === 0 ? ctx.moveTo(px,py) : ctx.lineTo(px,py);
          }
          ctx.closePath(); ctx.fill(); ctx.restore();
        }
        var raf = null;
        function frame(){
          ctx.clearRect(0,0,cv.width,cv.height);
          for(var i=sparks.length-1;i>=0;i--){
            var s = sparks[i]; s.life += s.spd;
            if(s.life >= 1){ sparks.splice(i,1); continue; }
            drawStar(s);
          }
          if(sparks.length){ raf = requestAnimationFrame(frame); } else { raf = null; }
        }
        function kick(){ if(!raf) raf = requestAnimationFrame(frame); }

        /* trail: emit sparkles wherever the pointer / finger travels */
        var lastX = innerWidth/2, lastY = innerHeight/2;
        function trail(x, y){
          var dx = x - lastX, dy = y - lastY;
          if(dx*dx + dy*dy > 150){
            addSpark(x + (Math.random()*10-5), y + (Math.random()*10-5));
            if(Math.random() < 0.4) addSpark(x + (Math.random()*16-8), y + (Math.random()*16-8));
            lastX = x; lastY = y; kick();
          }
        }
        document.addEventListener('pointermove', function(e){ trail(e.clientX, e.clientY); }, {passive:true});
        document.addEventListener('touchmove', function(e){ if(e.touches && e.touches[0]) trail(e.touches[0].clientX, e.touches[0].clientY); }, {passive:true});

        /* tap delight: a small burst when pressing anything interactive */
        var tapSel = 'a,button,.btn,[role="button"],input[type="submit"],label,summary,'
          + '.eh-catnav__item,.product-card,.collection-item,.eh-rank__card,.eh-csw__chip,'
          + '.ehcj__card,.ehcj__cta,.ehhb-store,.ehhb-store__btn,.ehhb-media';
        document.addEventListener('pointerdown', function(e){
          var t = e.target.closest && e.target.closest(tapSel);
          if(t){ burst(e.clientX, e.clientY, 9, 1.05); }
        }, {passive:true});

        /* add-to-cart celebration: a bigger burst */
        document.addEventListener('click', function(e){
          var b = e.target.closest && e.target.closest('.btn--add-to-cart,[name="add"],.product-form__cart-submit,.add_to_cart,.add-to-cart');
          if(b){ var r = b.getBoundingClientRect(); burst(r.left + r.width/2, r.top + r.height/2, 22, 1.5); }
        }, {passive:true});
      }catch(e){}
    }

    /* ---------- cursor-follow spotlight on product cards (desktop) ---------- */
    if(fine && !reduce){
      try{
        document.addEventListener('pointermove', function(e){
          var card = e.target.closest && e.target.closest('.product-card');
          if(!card) return;
          var r = card.getBoundingClientRect();
          card.style.setProperty('--eh-mx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
          card.style.setProperty('--eh-my', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
          card.classList.add('eh-spot');
        }, {passive:true});
        document.addEventListener('pointerout', function(e){
          var card = e.target.closest && e.target.closest('.product-card');
          if(card && (!e.relatedTarget || !card.contains(e.relatedTarget))) card.classList.remove('eh-spot');
        }, {passive:true});
      }catch(e){}
    }

  });
})();
